var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCertificateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33317 2.5C2.40817 2.5 1.6665 3.24167 1.6665 4.16667V12.5C1.6665 12.942 1.8421 13.366 2.15466 13.6785C2.46722 13.9911 2.89114 14.1667 3.33317 14.1667H9.99984V18.3333L12.4998 15.8333L14.9998 18.3333V14.1667H16.6665C17.1085 14.1667 17.5325 13.9911 17.845 13.6785C18.1576 13.366 18.3332 12.942 18.3332 12.5V6.66667V5V4.16667C18.3332 3.72464 18.1576 3.30072 17.845 2.98816C17.5325 2.67559 17.1085 2.5 16.6665 2.5H13.3332H3.33317ZM9.99984 4.16667L12.4998 5.83333L14.9998 4.16667V7.08333L17.4998 8.33333L14.9998 9.58333V12.5L12.4998 10.8333L9.99984 12.5V9.58333L7.49984 8.33333L9.99984 7.08333V4.16667ZM3.33317 4.16667H7.49984V5.83333H3.33317V4.16667ZM3.33317 7.5H5.83317V9.16667H3.33317V7.5ZM3.33317 10.8333H7.49984V12.5H3.33317V10.8333Z",
    fill: "#C7222A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificateIcon);
export default __webpack_public_path__ + "static/media/certificate-icon.c07258c9b9deee122d254f3b3ca346be.svg";
export { ForwardRef as ReactComponent };